module.exports = __webpack_public_path__ + "static/media/planning.260417ce.svg";